import store from "./store"


// local forage takes bit to be ready
export const waitForStorageToBeReady = async () => {
  await store.restored
}